<template>
  <div class="section container">
    <div class="section-header">
      <div class="section-title">
        <div class="section-icon section-icon-passkey" :class="brandClass()"></div>
        <div class="section-title-label">
          {{$t("profile_account_data_passkey_title")}}
        </div>
      </div>
      <div @keydown="ariaClick" role="button" tabindex="0" @click="handleEditMode()" class="section-edit pointer" :class="{'hidden': editDisabled}" v-if="(!editMode && !editDisabled && !(passkeyEntriesSorted.length === 0 && $c('show_passkey_feature_not_available_message')))">
        <div class="section-edit-icon"></div>
        <div class="section-edit-label">
          {{$t("profile_edit_button")}}
        </div>
      </div>
    </div>
    <div class="section-sub-header">
      {{(passkeyEntriesSorted.length === 0 && $c('show_passkey_feature_not_available_message')) ? $t("profile_account_data_passkey_feature_not_available") : $t("profile_account_data_passkey_subtitle")}}
    </div>
    
    <div v-if="editMode">
      <div>
        <div v-if="isPasskeyActivated" class="section-sub-header">
          <div class="passkey-entries-container">
            <PasskeyEntry 
              @editNameMode="passkeyEntryEditNameModeEvent" 
              @getPasskeys="getPasskeys" class="passkey-entry"
              @closeEditModeForPasskeyEntryWithUuid="(value) => passkeyUuidToClose = value" 
              v-for="passkeyEntry in passkeyEntriesSorted" 
              :key="passkeyEntry.uuid" 
              :passkey-entry="passkeyEntry"
              :passkeyEntryUuidInEditMode="passkeyEntryUuidInEditMode"
              :passkeyUuidToClose="passkeyUuidToClose">
            </PasskeyEntry>
          </div>
          <span class="passkey-feature-not-available" v-if="$c('show_passkey_feature_not_available_message')">{{ $t("profile_account_data_passkey_feature_not_available") }}</span>
          <div class="buttonsContainer flex_button_container">
            <OneButton
                :disabled="$c('show_passkey_feature_not_available_message') || isAddPasskeyButtonDisabled"
                :brandClass="brandClass()"
                :profileStyle="true"
                :type="'primary'"
                :label="$t('profile_account_data_passkey_entry_add')"
                @click="openInputPopUp()"
            />
            <OneButton
                :brandClass="brandClass()"
                :profileStyle="true"
                :type="'secondary'"
                :label="$t('profile_cancel_button')"
                @click="handleEditMode()"
            />
          </div>

        </div>
        <div v-if="!isPasskeyActivated" class="section-sub-header">
          <div class="activate-passkey-container" :class="brandClass()">
            <div class="activate-passkey-icon section-icon-passkey" :class="brandClass()"></div>
            <div class="activate-passkey-content">
              <div class="activate-passkey-title" :class="brandClass()">
                <span>{{$t("profile_account_data_passkey_edit_container_title_deactivated")}}</span>
              </div>
              <div class="activate-passkey-text">
                <p>{{$t("profile_account_data_passkey_edit_container_content_deactivated_1")}}</p>
                <p>{{$t("profile_account_data_passkey_edit_container_content_deactivated_2")}}</p>
                <p>{{$t("profile_account_data_passkey_edit_container_content_deactivated_3")}}</p>
                <p>{{$t("profile_account_data_passkey_edit_container_content_deactivated_4")}}</p>
              </div>
              <div class="buttonsContainer flex_button_container">
                <OneButton
                    :brandClass="brandClass()"
                    :profileStyle="true"
                    :type="'primary'"
                    :label="$t('profile_account_data_passkey_create_button')"
                    @click="openInputPopUp()"
                />
                <OneButton
                    :brandClass="brandClass()"
                    :profileStyle="true"
                    :type="'secondary'"
                    :label="$t('profile_cancel_button')"
                    @click="handleEditMode()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>
  </div>
  <PasskeyInputPopup 
    :showPasskeyInputPopup="showPasskeyInputPopup" 
    :passwordError="passwordError"
    :resetPasswordFormProp="resetPasswordForm"
    @resetPasswordError="resetPasswordError"
    @closePasskeyInputPopup="closePasskeyInputPopupFromUserClick"
    @userPasswordForPasskey="activatePasskey"></PasskeyInputPopup>
    <OneAlert 
      :brandClass="brandClass()" 
      v-if="errorModalData.showErrorModal" 
      :title="$t(errorModalData.title)" 
      :content="$t(errorModalData.body)" 
      :button_full_label="$t(errorModalData.buttonText)" 
      @close="errorModalData.showErrorModal = false"
      @full="errorModalData.showErrorModal = false">
    </OneAlert>
</template>
<script>
import oneUtils from "../../../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import useVuelidate from '@vuelidate/core';
import PasskeyInputPopup from "@/components/ProfileForm/components/PasskeySection/components/PasskeyInputPopup.vue";
import PasskeyEntry from "@/components/ProfileForm/components/PasskeySection/components/PasskeyEntry.vue";

import { defineComponent } from 'vue';
import {
  required
} from "@vuelidate/validators";

export default defineComponent({
  inject:['$c', '$t', 'brandClass'],
  mixins: [oneUtils.accessibilityMixin],
  name: "ProfilePasskey",
  components: {
    PasskeyInputPopup,
    PasskeyEntry
  },
  props: {
    editDisabled: {
      default: false,
      type: Boolean,
    },
    passkeyEntries: {
      type: Array
    },
    passkeyCount: {
      type: Number
    }
  },
  emits: ['getPasskeys'],
  data: () => ({
    passkeyUuidToClose: null,
    passkeyEntryUuidInEditMode: null,
    isAddPasskeyButtonDisabled: false,
    oneMoment: null,
    editMode: false,
    showPasskeyInputPopup: false,
    resetPasswordForm: false,
    maxPasskeyCount: 10,
    passwordError: false,
    outcomeMessageFromWC: null,
    errorModalData: {
      showErrorModal: false,
      title: "",
      body: "",
      buttonText: ""
    },
    knownDevices: {}
  }),
  computed: {
    isPasskeyActivated() {
      return this.passkeyEntries.length > 0;
    },
    passkeyEntriesSorted() {
      return this.passkeyEntries.sort((a, b) => {
        if(a.deviceName.indexOf("__") == -1)
            return -1;
        else if(b.deviceName.indexOf("__") == -1) {
            return 1;
        }
        const timestampA = parseInt(a.deviceName.split("__")[1]);
        const timestampB = parseInt(b.deviceName.split("__")[1]);

        return timestampB - timestampA;
      })
    }
  },
  methods: {
    passkeyEntryEditNameModeEvent(editNameModeEntry) {
      this.isAddPasskeyButtonDisabled = editNameModeEntry.value;
      this.passkeyEntryUuidInEditMode = editNameModeEntry.uuid;
    },
    removeLocalStorageParametersInWCRedirection() {
      window.localStorage.removeItem("oneid_access_token");
    },
    constructRedirectURLInWCRedirection() {
      const url = new URL(this.$store.getters.configure("env").base_legacy_url + "/oneid/profile");
      
      const accessToken = window['$startupwebcomponent'].oneid_access_token;
      const originalUrl = window.location.href;
      const configurationParams = this.$store.state.configurationParams;
      const section = oneUtils.enums.profilePages.ACCOUNT_DATA;

      const params = {
        accessToken,
        originalUrl,
        section,
        ...configurationParams
      };
      
      for (const param in params) {
        url.searchParams.set(param, params[param]);
      }
      
      return url.toString();
    },
    constructRedirectURLInAppRedirection() {
      let url = new URL(this.$store.getters.configure("env").base_legacy_url + "/oneid/profile");
      
      if(process.env.NODE_ENV === "pmt") {
        url = new URL("https://reverse.customer-pmt.bmwgroup.com" + "/oneid/profile");
      }

      const accessToken = window.localStorage.getItem("oneid_access_token");
      const configurationParams = this.$store.state.configurationParams;
      const section = oneUtils.enums.profilePages.ACCOUNT_DATA;
      const isFromApp = "true";

      const params = {
        accessToken,
        section,
        isFromApp,
        ...configurationParams
      };
      
      for (const param in params) {
        url.searchParams.set(param, params[param]);
      }
      
      return url.toString();
    },
    constructRedirectURLAfterWCRedirection() {
        if(!this.$route && this.$route.meta.wc_redirection) return "";
        const url = new URL(this.$route.meta.wc_redirection);
        
        const outcomeMessageFromWC = this.outcomeMessageFromWC;

        const params = {
          outcomeMessageFromWC,
        };
        
        for (const param in params) {
          url.searchParams.set(param, params[param]);
        }

        return url.toString();
    },
    closePasskeyInputPopupFromFlowFinished() {
      if(!(this.$route && this.$route.meta.wc_redirection)) {
        this.resetPasswordForm = !this.resetPasswordForm;
        this.showPasskeyInputPopup = false;
        if(this.$route.meta.app_redirection){
          try{
            window.addEventListener("click", (e) => {e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); return false}, true);
            setTimeout(() => window.close(), 4000);
          }catch(e){
            console.log('[PASSKEY ERROR] window.close not available');
          }
        }
      } else {
        const url = this.constructRedirectURLAfterWCRedirection();
        this.removeLocalStorageParametersInWCRedirection();
        window.location.href = url;
      }
    },
    closePasskeyInputPopupFromUserClick() {
      if(!(this.$route && this.$route.meta.wc_redirection)) {
        this.showPasskeyInputPopup = false;
        if(this.$route.meta.app_redirection){
          try{
            window.close();
          }catch(e){
            console.log('[PASSKEY ERROR] window.close not available');
          }
        }
      } else {
        this.outcomeMessageFromWC = "popup_closed";
        const url = this.constructRedirectURLAfterWCRedirection();
        this.removeLocalStorageParametersInWCRedirection();
        window.location.href = url;    
      }
    },
    resetPasswordError(value) {
      this.passwordError = value;
    },
    openInputPopUp(fromApp = false) {
      if(this.passkeyCount >= this.maxPasskeyCount) {
        this.openErrorModal(
          "profile_account_data_passkey_error_device_limit_exceeded_title", 
          "profile_account_data_passkey_error_device_limit_exceeded_body", 
          "profile_cancel_button"
        );
        return;
      }

      if(this.$c("enable_redirect_website_on_add_passkey") && !fromApp) { 
        window.open(this.constructRedirectURLInAppRedirection());
        return;
      } 

      if(!window.PublicKeyCredential || !navigator.credentials) {
        this.openErrorModal(
          "profile_account_data_passkey_error_passkey_creation_not_supported_title", 
          "profile_account_data_passkey_error_passkey_creation_not_supported_body", 
          "profile_cancel_button"
        );
        return;
      }

      const el = document.getElementsByTagName('v-profile');
      const isWC = !!el[0];

      if(!isWC) {
        this.showPasskeyInputPopup = true;
      } else {
        window.location.href = this.constructRedirectURLInWCRedirection();
      }
    },
    openErrorModal(title, body, buttonText) {
      this.errorModalData.title = title;
      this.errorModalData.body = body;
      this.errorModalData.buttonText = buttonText;
      this.errorModalData.showErrorModal = true;
    },
    notificationGenericError() {
      if(!(this.$route && this.$route.meta.wc_redirection)) {
        oneUtils.utils.showMessage("ERROR", this.$t('generic_system_error_personal'));
      } else {
        this.outcomeMessageFromWC = "error_generic";
      }
    },
    notificationSuccess() {
      if(!(this.$route && this.$route.meta.wc_redirection)) {
        oneUtils.utils.showMessage("SUCCESS", this.$t('profile_account_data_passkey_message_activated'));
      } else {
        this.outcomeMessageFromWC = "success";
      }
    },
    activatePasskey(password) {
     oneUtils.httpClient.passkeyRegisterStart().then((res1) => {
          const body = res1.data;
          body.callbacks[0].input[0].value = this.$store.getters.getUser?.email;
          body.callbacks[1].input[0].value = password;

          oneUtils.httpClient.passkeyRegisterStart(body).then((res2) => {
            let callback = res2.data?.callbacks?.find(el => el.type=="MetadataCallback");
            let output = callback && callback.output?.find(el => el.name="data ");
            let data = output?.value;
            if (!data) {
              throw new Error("Data object is empty");
            }


            const attestation = (oneUtils.utils.isIOS() && this.versionCompare(oneUtils.utils.getOsVersion(), "17.0.1") === -1) ? "none" : "direct";

            var publicKey = {
              challenge: Uint8Array.from(atob(data.challenge), c => c.charCodeAt(0)).buffer,
              // Relying Party:
              rp: {
                name: data.relyingPartyName
                //id: "." + window.location.host.split(".").splice(-2).join(".")
              },
              // User:
              user: {
                id: Uint8Array.from(data.userId, (c) =>  c.charCodeAt(0) ),
                name: this.$store.getters.getUser?.email,
                displayName: this.$store.getters.getUser?.email
              },
              pubKeyCredParams: data._pubKeyCredParams,
              attestation: attestation,
              timeout: data.timeout,
              excludeCredentials: data._excludeCredentials,
              authenticatorSelection: data._authenticatorSelection
            };

            navigator.credentials.create({publicKey: publicKey}).then( (newCredentialInfo) => {
              const rawId = newCredentialInfo.id;
              const clientData = String.fromCharCode.apply(null, new Uint8Array(newCredentialInfo.response.clientDataJSON));
              const keyData = new Int8Array(newCredentialInfo.response.attestationObject).toString();       

              const deviceName = this.getDeviceNameFromAttestationObject(newCredentialInfo.response.attestationObject);
              const timestamp = this.oneMoment.getCurrentTimestampWithMilliseconds();

              const deviceNameWithTimestamp = deviceName + "__" + timestamp;

              const bodyRegisterComplete = res2.data;
              bodyRegisterComplete.callbacks[1].input[0].value = clientData + "::" + keyData + "::" + rawId;

              oneUtils.httpClient.passkeyRegisterComplete(bodyRegisterComplete, deviceNameWithTimestamp).then((resRegisterComplete) => {
                this.notificationSuccess();
                this.closePasskeyInputPopupFromFlowFinished();

                if(!(this.$route && this.$route.meta.wc_redirection)) {
                  this.getPasskeys();
                }
              }).catch((err) => {
                console.log('err step 2: ', err);
                this.notificationGenericError();
                this.closePasskeyInputPopupFromFlowFinished();
              });
            }).catch((err) => {
              if(err.name !== oneUtils.enums.errorReasons.NAVIGATOR_TIMEOUT) { //Timeout or user canceled passkey registration
                this.notificationGenericError();
              }
              console.log('Navigator err: ',err);
              this.closePasskeyInputPopupFromFlowFinished();
            });
            
          }).catch((err) => {
            if(err.errorPayload.errorMessage === oneUtils.enums.errorReasons.PASSKEY_REGISTRATION_WRONG_PASSWORD) { //Wrong password
              this.passwordError = true;
            } else {
              this.notificationGenericError();
              this.closePasskeyInputPopupFromFlowFinished();
            }
            console.log('err step 1.2',err);
          });
        }).catch((err) => {
          console.log('err step 1.1',err);
          this.notificationGenericError();
          this.closePasskeyInputPopupFromFlowFinished();
        })
     this.editMode = false;
    },
    getDeviceNameFromAttestationObject(attestationObject) {
      let attestationObjectHex = [...new Uint8Array(attestationObject)]
                      .map(x => x.toString(16).padStart(2, '0'))
                      .join('');


      for(let aaguid in this.knownDevices) {
        const cleanDeviceAaguid = aaguid.split("-").join("");
        if(attestationObjectHex.indexOf(cleanDeviceAaguid) !== -1) {
          return this.knownDevices[aaguid].name;
        }
      }

      return "Passkey " + (this.passkeyEntries.length + 1);
    },
    getPasskeys() {
      this.$emit('getPasskeys')
    },
    handleEditMode(){
      this.editMode = !this.editMode
      this.isAddPasskeyButtonDisabled = false;
    },
    versionCompare(v1, v2) {
        const v1Array = v1.split(".");
        const v2Array = v2.split(".");

        for(let i = 0; i < Math.min(v1Array.length, v2Array.length); i++) {
          if(Number(v1[i]) < Number(v2[i])) {
            return -1;
          } else if(Number(v1[i]) > Number(v2[i])) {
            return 1;
          }
        }

        if(v1Array.length > v2Array.length) return -1;
        else if(v1Array.length > v2Array.length) return 1;
        return 0;
    }
  },
  async mounted() {
    const query = Object.assign({}, oneUtils.utils.getQueryParams());
    if(this.$route && this.$route.meta.wc_redirection) {
      this.handleEditMode();
      this.openInputPopUp();
      delete query.accessToken;
      const url = new URL(window.location.origin + window.location.pathname);

      for (const param in query) {
        url.searchParams.set(param, query[param]);
      }
      window.history.pushState("", "", url.toString().replace("oneid/", "oneid/#/profile"));
    } else if (query.outcomeMessageFromWC) {
      this.handleEditMode();
      switch (query.outcomeMessageFromWC) {
        case "error_generic":
          this.notificationGenericError();
          break;
        case "success":
          this.notificationSuccess();
          break;
        case "popup_closed":
        default:
          break;
      }
      delete query.outcomeMessageFromWC;
      const url = new URL(window.location.origin + window.location.pathname);

      for (const param in query) {
        url.searchParams.set(param, query[param]);
      }
      window.history.pushState("", "", url.toString());
    }
    if(this.$route && this.$route.meta.app_redirection) {
      this.handleEditMode();
      this.openInputPopUp(query.isFromApp);
      delete query.accessToken;
      delete query.isFromApp;
      const url = new URL(window.location.origin + window.location.pathname);

      for (const param in query) {
        url.searchParams.set(param, query[param]);
      }
      window.history.pushState("", "", url.toString().replace("oneid/", "oneid/#/profile"));
    }
    
    const awaitImportOneMoment = await import('../../../../../../gcdm-one-library/gcdm-one-moment/src/bootstrap');
    this.oneMoment = (awaitImportOneMoment).default;

    const awaitImportKnownDevices = await import('../knownDevices.json');
    this.knownDevices = awaitImportKnownDevices.default;
  }
});
</script>

<style lang="scss" scoped>

.section-icon-passkey {
  background-size: 100%;
  background-image: url('~@/assets/default/light/passkey-default-light.svg');
  &.__d{
    background-image: url('~@/assets/default/dark/passkey-default-dark.svg');
  }
  &.__rr {
    background-image: url('~@/assets/default/dark/passkey-default-dark.svg');
  }
}
.buttonsContainer{
  margin-top: 32px;
}
.passkey-feature-not-available {
    margin-top: 24px;
}
.edit-icon{
  background-image: url('~@/assets/default/light/edit-default-light.svg');
  width: 12px;
  height: 20px;
  background-repeat: no-repeat;
}
.section-edit-icon{
  background-image: url('~@/assets/default/light/edit-default-light.svg');
  width: 12px;
  height: 20px;
  background-repeat: no-repeat;
}
.activate-passkey-container {
  background:$grey12;
  position: relative;
  display: flex;
  padding: 24px;
  margin-top: 32px;
  &.__d {
    color: $black;
  }
  .activate-passkey-icon {
    width: 24px;
    height: 24px;
    margin-bottom: -2px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('~@/assets/default/light/passkey-default-light.svg');
  }
  .activate-passkey-content {
    padding: 0 20px;
    width: 100%;
    .activate-passkey-title {
      font-weight: bold;
    }
    .activate-passkey-text {
      line-height: 24px;
      margin: 24px 0;
    }
  }
}
.passkey-entries-container {
    margin: 24px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
  .passkey-entries-title {
    margin-bottom: 8px;
    margin-top: 24px;
    font-size: 14px;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    color: $grey5;
    display: block;
    &.__d {
      color: white!important;;
    }
    &.__rr {
      color: $grey;
      text-transform: uppercase;
      font-family: RivieraNights-Bold;
    }
    &.__m{
      color: black;
    }
    &.__m{
      color: black;
    }
    &.__t{
      color: black;
    }
    &.__t{
      font-family: ToyotaSemibold;
    }
    &.__alphabet{
      color: $grey10;
    }
  }
</style>